import { render, staticRenderFns } from "./IconsBuilding.vue?vue&type=template&id=a07ddb50&scoped=true"
import script from "./IconsBuilding.vue?vue&type=script&lang=js"
export * from "./IconsBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07ddb50",
  null
  
)

export default component.exports